<template>
  <product title="Amazfit 全压胶防风透湿冲锋衣"
    :swiper-data="swiperData"
    :slogan="slogan"
    price="199"
    :colors="colors"
    :relatived-products="relativedProducts"
    :detail-images="detailImages"
    :param-images="paramImages"
    buy-link="https://j.youzan.com/hJUkKh"
  ></product>
</template>

<script>
import { CDN_URL } from '@/config'
import Product from '../Product'

export default {
  name: 'jackets',
  components: {
    Product
  },
  data () {
    return {
      slogan: '排湿不闷汗 | 防风防水 | 三层复合面料 | 全件压胶工艺',
      colors: [
        '石墨黑',
        '玄青色',
        '铬铁黄'
      ],
      swiperData: [
        [
          CDN_URL + '/images/product/jackets/swiper/4.png',
          CDN_URL + '/images/product/jackets/swiper/5.png',
          CDN_URL + '/images/product/jackets/swiper/6.png'
        ],
        [
          CDN_URL + '/images/product/jackets/swiper/7.png',
          CDN_URL + '/images/product/jackets/swiper/8.png',
          CDN_URL + '/images/product/jackets/swiper/9.png'
        ],
        [
          CDN_URL + '/images/product/jackets/swiper/1.png',
          CDN_URL + '/images/product/jackets/swiper/2.png',
          CDN_URL + '/images/product/jackets/swiper/3.png'
        ]
      ],
      relativedProducts: [
      ],
      detailImages: [
        CDN_URL + '/images/product/jackets/detail/01.jpg',
        CDN_URL + '/images/product/jackets/detail/02.jpg',
        CDN_URL + '/images/product/jackets/detail/03.jpg',
        CDN_URL + '/images/product/jackets/detail/04.jpg',
        CDN_URL + '/images/product/jackets/detail/05.jpg',
        CDN_URL + '/images/product/jackets/detail/06.jpg',
        CDN_URL + '/images/product/jackets/detail/07.jpg',
        CDN_URL + '/images/product/jackets/detail/08.jpg',
        CDN_URL + '/images/product/jackets/detail/09.jpg',
        CDN_URL + '/images/product/jackets/detail/10.jpg',
        CDN_URL + '/images/product/jackets/detail/11.jpg',
        CDN_URL + '/images/product/jackets/detail/12.jpg'
      ],
      paramImages: [
        CDN_URL + '/images/product/jackets/detail/13.jpg'
      ]
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
s
,
